export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 7.07b75ceb.pdf";